import React from 'react';
import { useTranslation } from 'react-i18next';
import { Body, Button, Image } from '@sumup-oss/circuit-ui';

import styles from './EscalationOptions.module.css';

import GetInTouch from 'src/assets/icons/GetInTouch';

const qrImage =
  'https://images.ctfassets.net/214q1nptnllb/2AQX9oOjBwg0SKRo9KGyfj/be337b1a47db1aa7dd30022703edf1dd/support-qr-with-support-centre.png';

const EscalationOptions: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.description}>
        <GetInTouch />
        <div className={styles.cta_container}>
          <Body>{t('article.escalation.cta_description')}</Body>
          <Button
            className={styles.cta}
            href={'https://me.sumup.com/support/?origin=support_centre'}
            target="_blank"
            variant="primary"
          >
            {t('phone_banner.title')}
          </Button>
        </div>
      </div>
      <div className={styles.separator}>
        <div className={styles.line} />
        <div className={styles.separatorText}>
          <Body>{t('common.or')}</Body>
        </div>
      </div>
      <div className={styles.qrContainer}>
        <Image className={styles.qrImage} src={qrImage} alt="qr code" />
        <div className={styles.qrText}>
          <Body>{t('article.escalation.qr_description')}</Body>
        </div>
      </div>
    </div>
  );
};

export default EscalationOptions;
